import { SunIcon } from '@practium/ui';
import { useThemePreference } from '@practium/features/theme';
import styles from './ThemeToggle.module.css';

export const ThemeToggle = () => {
	const { toggleMode, isDark, isThemePreferenceBusy } = useThemePreference();

	return (
		<button
			className={styles.themeToggle}
			onClick={toggleMode}
			disabled={isThemePreferenceBusy}
			aria-label={`Trocar para tema ${isDark ? 'claro' : 'escuro'}`}
		>
			<SunIcon className={styles.themeIcon} />
		</button>
	);
};
